export const DotSeparator = () => {
    return <span aria-hidden className="size-0.5 shrink-0 rounded-full bg-cm-p-text-secondary" />;
};
